import { useLayoutEffect, useRef } from "react";

/** The sizes tried, in vh, biggest first: the first is the size the stylesheet gives the box. */
const SIZES = [3.4, 3.1, 2.8, 2.5, 2.2];

/**
 * A paragraph that wraps, in a box of a fixed height: the type steps down until every line is
 * inside. For the sitting-out list, which grows by eight names when a court closes.
 */
export function FitLines({ children }: { children: string }) {
  const ref = useRef<HTMLParagraphElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fit = () => {
      for (const size of SIZES) {
        el.style.fontSize = size === SIZES[0] ? "" : `${size}vh`;
        if (el.scrollHeight <= el.clientHeight + 1) break;
      }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    void document.fonts?.ready.then(fit);
    return () => ro.disconnect();
  }, [children]);
  return <p ref={ref}>{children}</p>;
}
